/* eslint-disable @typescript-eslint/no-unused-vars, no-unused-vars */
import type { DSControlledDateTimePickerT } from '../index.js';

// ── Helpers ────────────────────────────────────────────────────────────────────────────────────
const fn = (): object => ({});
const calendarDayFn = ({
  isSelected,
  isFocused,
  isDisabled,
  isOutOfRange,
  isStartRangeDay,
  isEndRangeDay,
  isDayInRangeImproper,
  isDayInRange,
  metaDay,
}: DSControlledDateTimePickerT.CalendarDaySlotArguments): object => ({});

// ── full-date-time ─────────────────────────────────────────────────────────────────────────────
// root + dateInputs + timeInputs + clearBtn + calendarContent + timewheelContent
// + calendarTimewheelContent + calendarTimewheelFooter + calendarTimewheelPickerWrapper
const slotsFullDateTime: DSControlledDateTimePickerT.Slots<'full-date-time'> = {
  dsControlleddatetimepickerRoot: fn,
  dsControlleddatetimepickerTimePickerMonthInput: fn,
  dsControlleddatetimepickerTimePickerDayInput: fn,
  dsControlleddatetimepickerTimePickerYearInput: fn,
  dsControlleddatetimepickerTimePickerHourInput: fn,
  dsControlleddatetimepickerTimePickerMinuteInput: fn,
  dsControlleddatetimepickerTimePickerMeridiemInput: fn,
  dsControlleddatetimepickerClearBtn: fn,
  dsControlleddatetimepickerCalendarDay: calendarDayFn,
  dsControlleddatetimepickerCalendarHeaderLabel: fn,
  dsControlleddatetimepickerCalendarHeaderButtons: fn,
  dsControlleddatetimepickerCalendarHeaderWeeklyDayList: fn,
  dsControlleddatetimepickerCalendarControllerWrapper: fn,
  dsControlleddatetimepickerTimewheelTimeButton: fn,
  dsControlleddatetimepickerTimewheelTimeChangeButton: fn,
  dsControlleddatetimepickerTimewheelHeaderLabel: fn,
  dsControlleddatetimepickerTimewheelControllerWrapper: fn,
  dsControlleddatetimepickerCalendarTimewheelControllerWrapper: fn,
  dsControlleddatetimepickerCalendarTimewheelContextFooter: fn,
  dsControlleddatetimepickerCalendarTimewheelTriggerIcon: fn,
  dsControlleddatetimepickerCalendarTimewheelContextContentWrapper: fn,
};

// ── date-time-inputs ───────────────────────────────────────────────────────────────────────────
// root + dateInputs + timeInputs + clearBtn
const slotsDateTimeInputs: DSControlledDateTimePickerT.Slots<'date-time-inputs'> = {
  dsControlleddatetimepickerRoot: fn,
  dsControlleddatetimepickerTimePickerMonthInput: fn,
  dsControlleddatetimepickerTimePickerDayInput: fn,
  dsControlleddatetimepickerTimePickerYearInput: fn,
  dsControlleddatetimepickerTimePickerHourInput: fn,
  dsControlleddatetimepickerTimePickerMinuteInput: fn,
  dsControlleddatetimepickerTimePickerMeridiemInput: fn,
  dsControlleddatetimepickerClearBtn: fn,
};

// ── date-time-picker ───────────────────────────────────────────────────────────────────────────
// root + calendarContent + timewheelContent + calendarTimewheelContent
// + calendarTimewheelFooter + calendarTimewheelPickerWrapper
const slotsDateTimePicker: DSControlledDateTimePickerT.Slots<'date-time-picker'> = {
  dsControlleddatetimepickerRoot: fn,
  dsControlleddatetimepickerCalendarDay: calendarDayFn,
  dsControlleddatetimepickerCalendarHeaderLabel: fn,
  dsControlleddatetimepickerCalendarHeaderButtons: fn,
  dsControlleddatetimepickerCalendarHeaderWeeklyDayList: fn,
  dsControlleddatetimepickerCalendarControllerWrapper: fn,
  dsControlleddatetimepickerTimewheelTimeButton: fn,
  dsControlleddatetimepickerTimewheelTimeChangeButton: fn,
  dsControlleddatetimepickerTimewheelHeaderLabel: fn,
  dsControlleddatetimepickerTimewheelControllerWrapper: fn,
  dsControlleddatetimepickerCalendarTimewheelControllerWrapper: fn,
  dsControlleddatetimepickerCalendarTimewheelContextFooter: fn,
  dsControlleddatetimepickerCalendarTimewheelTriggerIcon: fn,
  dsControlleddatetimepickerCalendarTimewheelContextContentWrapper: fn,
};

// ── date-time-picker-controller-only ──────────────────────────────────────────────────────────
// root + calendarContent + timewheelContent + calendarTimewheelContent + calendarTimewheelFooter
const slotsDateTimePickerControllerOnly: DSControlledDateTimePickerT.Slots<'date-time-picker-controller-only'> = {
  dsControlleddatetimepickerRoot: fn,
  dsControlleddatetimepickerCalendarDay: calendarDayFn,
  dsControlleddatetimepickerCalendarHeaderLabel: fn,
  dsControlleddatetimepickerCalendarHeaderButtons: fn,
  dsControlleddatetimepickerCalendarHeaderWeeklyDayList: fn,
  dsControlleddatetimepickerCalendarControllerWrapper: fn,
  dsControlleddatetimepickerTimewheelTimeButton: fn,
  dsControlleddatetimepickerTimewheelTimeChangeButton: fn,
  dsControlleddatetimepickerTimewheelHeaderLabel: fn,
  dsControlleddatetimepickerTimewheelControllerWrapper: fn,
  dsControlleddatetimepickerCalendarTimewheelControllerWrapper: fn,
  dsControlleddatetimepickerCalendarTimewheelContextFooter: fn,
};

// ── full-date ──────────────────────────────────────────────────────────────────────────────────
// root + dateInputs + clearBtn + calendarContent + calendarFooter + calendarPickerWrapper
const slotsFullDate: DSControlledDateTimePickerT.Slots<'full-date'> = {
  dsControlleddatetimepickerRoot: fn,
  dsControlleddatetimepickerTimePickerMonthInput: fn,
  dsControlleddatetimepickerTimePickerDayInput: fn,
  dsControlleddatetimepickerTimePickerYearInput: fn,
  dsControlleddatetimepickerClearBtn: fn,
  dsControlleddatetimepickerCalendarDay: calendarDayFn,
  dsControlleddatetimepickerCalendarHeaderLabel: fn,
  dsControlleddatetimepickerCalendarHeaderButtons: fn,
  dsControlleddatetimepickerCalendarHeaderWeeklyDayList: fn,
  dsControlleddatetimepickerCalendarControllerWrapper: fn,
  dsControlleddatetimepickerCalendarContextFooter: fn,
  dsControlleddatetimepickerCalendarTriggerIcon: fn,
  dsControlleddatetimepickerCalendarContextContentWrapper: fn,
};

// ── date-inputs ────────────────────────────────────────────────────────────────────────────────
// root + dateInputs + clearBtn
const slotsDateInputs: DSControlledDateTimePickerT.Slots<'date-inputs'> = {
  dsControlleddatetimepickerRoot: fn,
  dsControlleddatetimepickerTimePickerMonthInput: fn,
  dsControlleddatetimepickerTimePickerDayInput: fn,
  dsControlleddatetimepickerTimePickerYearInput: fn,
  dsControlleddatetimepickerClearBtn: fn,
};

// ── date-picker ────────────────────────────────────────────────────────────────────────────────
// root + calendarContent + calendarFooter + calendarPickerWrapper
const slotsDatePicker: DSControlledDateTimePickerT.Slots<'date-picker'> = {
  dsControlleddatetimepickerRoot: fn,
  dsControlleddatetimepickerCalendarDay: calendarDayFn,
  dsControlleddatetimepickerCalendarHeaderLabel: fn,
  dsControlleddatetimepickerCalendarHeaderButtons: fn,
  dsControlleddatetimepickerCalendarHeaderWeeklyDayList: fn,
  dsControlleddatetimepickerCalendarControllerWrapper: fn,
  dsControlleddatetimepickerCalendarContextFooter: fn,
  dsControlleddatetimepickerCalendarTriggerIcon: fn,
  dsControlleddatetimepickerCalendarContextContentWrapper: fn,
};

// ── date-picker-controller-only ────────────────────────────────────────────────────────────────
// root + calendarContent + calendarFooter
const slotsDatePickerControllerOnly: DSControlledDateTimePickerT.Slots<'date-picker-controller-only'> = {
  dsControlleddatetimepickerRoot: fn,
  dsControlleddatetimepickerCalendarDay: calendarDayFn,
  dsControlleddatetimepickerCalendarHeaderLabel: fn,
  dsControlleddatetimepickerCalendarHeaderButtons: fn,
  dsControlleddatetimepickerCalendarHeaderWeeklyDayList: fn,
  dsControlleddatetimepickerCalendarControllerWrapper: fn,
  dsControlleddatetimepickerCalendarContextFooter: fn,
};

// ── full-time ──────────────────────────────────────────────────────────────────────────────────
// root + timeInputs + clearBtn + timewheelContent + timewheelFooter + timewheelPickerWrapper
const slotsFullTime: DSControlledDateTimePickerT.Slots<'full-time'> = {
  dsControlleddatetimepickerRoot: fn,
  dsControlleddatetimepickerTimePickerHourInput: fn,
  dsControlleddatetimepickerTimePickerMinuteInput: fn,
  dsControlleddatetimepickerTimePickerMeridiemInput: fn,
  dsControlleddatetimepickerClearBtn: fn,
  dsControlleddatetimepickerTimewheelTimeButton: fn,
  dsControlleddatetimepickerTimewheelTimeChangeButton: fn,
  dsControlleddatetimepickerTimewheelHeaderLabel: fn,
  dsControlleddatetimepickerTimewheelControllerWrapper: fn,
  dsControlleddatetimepickerTimewheelContextFooter: fn,
  dsControlleddatetimepickerTimewheelTriggerIcon: fn,
  dsControlleddatetimepickerTimewheelContextContentWrapper: fn,
};

// ── time-inputs ────────────────────────────────────────────────────────────────────────────────
// root + timeInputs + clearBtn
const slotsTimeInputs: DSControlledDateTimePickerT.Slots<'time-inputs'> = {
  dsControlleddatetimepickerRoot: fn,
  dsControlleddatetimepickerTimePickerHourInput: fn,
  dsControlleddatetimepickerTimePickerMinuteInput: fn,
  dsControlleddatetimepickerTimePickerMeridiemInput: fn,
  dsControlleddatetimepickerClearBtn: fn,
};

// ── time-picker ────────────────────────────────────────────────────────────────────────────────
// root + timewheelContent + timewheelFooter + timewheelPickerWrapper
const slotsTimePicker: DSControlledDateTimePickerT.Slots<'time-picker'> = {
  dsControlleddatetimepickerRoot: fn,
  dsControlleddatetimepickerTimewheelTimeButton: fn,
  dsControlleddatetimepickerTimewheelTimeChangeButton: fn,
  dsControlleddatetimepickerTimewheelHeaderLabel: fn,
  dsControlleddatetimepickerTimewheelControllerWrapper: fn,
  dsControlleddatetimepickerTimewheelContextFooter: fn,
  dsControlleddatetimepickerTimewheelTriggerIcon: fn,
  dsControlleddatetimepickerTimewheelContextContentWrapper: fn,
};

// ── time-picker-controller-only ────────────────────────────────────────────────────────────────
// root + timewheelContent + timewheelFooter
const slotsTimePickerControllerOnly: DSControlledDateTimePickerT.Slots<'time-picker-controller-only'> = {
  dsControlleddatetimepickerRoot: fn,
  dsControlleddatetimepickerTimewheelTimeButton: fn,
  dsControlleddatetimepickerTimewheelTimeChangeButton: fn,
  dsControlleddatetimepickerTimewheelHeaderLabel: fn,
  dsControlleddatetimepickerTimewheelControllerWrapper: fn,
  dsControlleddatetimepickerTimewheelContextFooter: fn,
};

// ── PolymorphicSlots spot-check ────────────────────────────────────────────────────────────────
// Verifies that the object form is accepted (all keys optional) and that the CalendarDay
// function form carries the typed args through PolymorphicSlots<T>.
const polyDatePicker: DSControlledDateTimePickerT.PolymorphicSlots<'date-picker'> = {
  dsControlleddatetimepickerRoot: { 'aria-label': 'test' },
  dsControlleddatetimepickerCalendarDay: { 'aria-label': 'test' },
};
const polyCalendarDayFn: DSControlledDateTimePickerT.PolymorphicSlots<'date-picker'>['dsControlleddatetimepickerCalendarDay'] =
  ({ isSelected, isDayInRangeImproper, metaDay }: DSControlledDateTimePickerT.CalendarDaySlotArguments) => ({});
